<template>
  <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">

    <div class="inner" style="max-width: 100%;">
    <div class="image"><img class="resize-image" src="/assets/images/landingpage/ja/metaxpro_logo.jpg"/></div>
    </div>
    <div class="centering_item1">
    <div class="text-center"><p><span class="bold f-large calibli-bold">{{ $t('atemcard-landingpage.text1') }}</span><span class="bold f-middle">{{ $t('atemcard-landingpage.text2') }}</span></p></div>
    <div class="red-border">
    <div class="paragraph2"><p class="text bold f-large text-red">{{ $t('atemcard-landingpage.text62') }}</p></div>
    <br>
    <div class="paragraph"><p class="text padding bold f-middle text-red">{{ $t('atemcard-landingpage.text63') }}</p></div>
    <div class="paragraph"><p class="text padding bold f-middle text-red">{{ $t('atemcard-landingpage.text64') }}</p></div>
    <br>
    <div class="paragraph"><p class="text padding bold f-middle text-red">{{ $t('atemcard-landingpage.text65') }}</p></div>
    <div class="paragraph"><p class="text padding bold f-middle text-red">{{ $t('atemcard-landingpage.text66') }}</p></div>
    <div class="paragraph"><p class="text padding bold f-middle text-red">{{ $t('atemcard-landingpage.text67') }}</p></div>
    <div class="paragraph"><p class="text padding bold f-middle text-red">{{ $t('atemcard-landingpage.text68') }}</p></div>
    <br>
    <div class="paragraph"><p class="text padding bold f-middle text-red">{{ $t('atemcard-landingpage.text69') }}</p></div>
    <br>
    </div>
  </div>
  </div>
</template>
  <script>
      import AuthUtil from '../../utils/AuthUtil';
      import languageService from '../../services/LanguageService';

      // 会員種別追加対応
      import UserService from "../../services/UserService";

      export default {
          name: 'landingpage',

          components: {
          },

          data() {
              return {
                  isChild: false,
              }
          },

          async created() {
              if (AuthUtil.isAuth()) {
                  this.fetchUserFrontendData();
              }
              this.lang = languageService.getCurrentLanguageShortCode();
          },

          methods: {
              async fetchUserFrontendData() {
                  const data = (await UserService.getUserFrontendData()).data;
                  this.isChild = data.is_child;
              },

          },
      }



  </script>
  <style scoped>


  .centering_item1 {
        max-width: 600px; /*幅指定 */
        margin:  0 auto;/* 中央寄せ */
    }


  .flex-item {
    width: 43%;
    justify-content: flex-start;
    padding: 20px;
  }

  .image-metaxpro {
    float: center;
    width: 80%;
  /*  min-width:320px;*/
  }

  .image-atemcard {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .image-left {
    display: flex;
    justify-content: left;
    align-items: left;
  }

  .resize-image {
   max-width: 800px;
   min-width: 240px;
  }

  .resize-image img {
   width: 100%;
  }

  .image {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .paragraph {
    display: flex;
    align-items: center;
  }

  .paragraph2 {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .text-right {
   text-align: right;
  }

  .text-left {
   text-align: left;
  }

  .textdeco {
   text-decoration:underline;
  }

  .bold {
   font-weight:bold;
  }

  .padding {
    padding-left: 1em;
  }

  .padding4 {
    padding-left: 4em;
  }

  .calibli-bold {
    font-family:Calibri-Bold_ap;
    text-shadow:1px 3px 3px #513c3c;
  }

  .text-red {
   color: red;
  }

  .v-center {
   vertical-align: middle;
  }

  .step {
   overflow: hidden;
   margin-top: 0;
   margin-bottom: 0;
  }
  .step-item1 {
    border: 2px solid #1b0303;
    font-weight: bold;
    float: left;
    text-align: left;
    padding: 0;
  }

  .step-item2 {
    text-align: left;
    margin: 0;
  }

  .btn--metaxpro,
  a.btn--metaxpro {
    color: #fff;
    background-color: #000000;
    width: 400px;
  }

  .btn--metaxpro:hover,
  a.btn--metaxpro:hover {
    color: #fff;
    background: #f56500;
  }

  .btn--atemcard,
  a.btn--atemcard {
    color: #fff;
    background-color: #6A5ACD;
    width: 400px;
  }

  .btn--atemcard:hover,
  a.btn--atemcard:hover {
    color: #fff;
    background: #f56500;
  }

  .f-large {
   font-size: 50px;
  }

  .f-middle {
   font-size: 20px;
  }

  .block-left {
   float: left;
   width: 10%;
  }

  .block-right {
   float: right;
   width: 10%;
  }

  .block-clear {
    clear: both;
  }

  .bg-orange {
   background-color: orange;
  }

  .red-border {
    padding: 15px;
    margin-bottom: 15px;
    border: 1px solid red;
  }

  @font-face {
    font-family: Calibri-Bold_ap;
    src: url("fonts/Calibri-Bold_ap.woff") format("woff");
  }


  </style>
